import { useMemo } from 'react';

import {
  MessagesMessageThreadParticipantFragment,
  MessageThreadsSuccessFragment,
} from 'Src/generated/graphql';

import useSelectedMessageThread from './useSelectedMessageThread';

export const reduceThreadParticipants = (
  selectedMessageThread?: MessageThreadsSuccessFragment['nodes'][number],
) => {
  if (!selectedMessageThread) {
    return {};
  }
  return selectedMessageThread.participants.nodes.reduce((acc, node) => {
    return {
      ...acc,
      [node.id]: node,
    };
  }, {});
};

export default function useSelectedMessageThreadParticipants() {
  const selectedMessageThread = useSelectedMessageThread();
  return useMemo((): {
    [key: string]: MessagesMessageThreadParticipantFragment;
  } => {
    return reduceThreadParticipants(selectedMessageThread);
  }, [selectedMessageThread]);
}
